import { AuthorPack, Business, Premium, Standard } from "../../Constant"

export const StandardData = [
    {
        prize: '$10',
        title: 'Standard',
        month: '/month',
        storage1: '50GB',
        props1: 'Disk Space',
        storage2: '50',
        props2: 'Email Accounts',
        storage3: '50GB',
        props3: 'Bandwidth',
        storage4: '10',
        props4: 'Subdomains',
        storage5: '15',
        props5: 'Domains',
    },
    {
        prize: '$20',
        title: 'PREMIUM',
        month: '/month',
        storage1: '20GB',
        props1: 'Disk Space',
        storage2: '20',
        props2: 'Email Accounts',
        storage3: '20GB',
        props3: 'Bandwidth',
        storage4: '20',
        props4: 'Subdomains',
        storage5: '20',
        props5: 'Domains',
    },
    {
        prize: '$30',
        title: 'AUTHER PACK',
        month: '/month',
        storage1: '30GB',
        props1: 'Disk Space',
        storage2: '30',
        props2: 'Email Accounts',
        storage3: '30GB',
        props3: 'Bandwidth',
        storage4: '25',
        props4: 'Subdomains',
        storage5: '25',
        props5: 'Domains',
    },
    {
        prize: '$40',
        title: 'BUSINESS',
        month: '/month',
        storage1: '40GB',
        props1: 'Disk Space',
        storage2: '40',
        props2: 'Email Accounts',
        storage3: '40GB',
        props3: 'Bandwidth',
        storage4: '30',
        props4: 'Subdomains',
        storage5: '30',
        props5: 'Domains',
    },
]

export const SmallCard = [
    {
        title: 'Standard',
        prize: '$15'
    },
    {
        title: 'Business',
        prize: '$25'
    },
    {
        title: 'Premium',
        prize: '$35'
    },
    {
        title: 'Extra',
        prize: '$45'
    },
]

export const Membershipdata = [
    {
        title : Standard,
        price : '$10',
        data : [
            {
                space :'50GB',
                name:'Disk Space'
            },
            {
                space :'50',
                name:'Email Accounts'
            },
            {
                space :'50GB',
                name:'Bandwidth'
            },
            {
                space :'10',
                name:'Subdomains'
            },
            {
                space :'15',
                name:'Domains'
            }
        ]
    },    
    {
        title : Business,
        price : '$20',
        data : [
            {
                space :'60GB',
                name:'Disk Space'
            },
            {
                space :'60',
                name:'Email Accounts'
            },
            {
                space :'60GB',
                name:'Bandwidth'
            },
            {
                space :'15',
                name:'Subdomains'
            },
            {
                space :'20',
                name:'Domains'
            }
        ]
    },    
    {
        title : Premium,
        price : '$30',
        data : [
            {
                space :'70GB',
                name:'Disk Space'
            },
            {
                space :'70',
                name:'Email Accounts'
            },
            {
                space :'70GB',
                name:'Bandwidth'
            },
            {
                space :'25',
                name:'Subdomains'
            },
            {
                space :'30',
                name:'Domains'
            }
        ]
    },    
    {
        title : AuthorPack,
        price : '$40',
        data : [
            {
                space :'80GB',
                name:'Disk Space'
            },
            {
                space :'80',
                name:'Email Accounts'
            },
            {
                space :'80GB',
                name:'Bandwidth'
            },
            {
                space :'25',
                name:'Subdomains'
            },
            {
                space :'30',
                name:'Domains'
            }
        ]
    },    
]